import { override } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import AffixedSidebar from 'flarum/forum/components/AffixedSidebar';
function cleanupAffix($sidebar) {
  const $affixElement = $sidebar.find('> ul');
  $(window).off('.affix');
  $affixElement.removeClass('affix affix-top affix-bottom').removeData('bs.affix');
}

/**
 * Keep profile side navigation in normal document flow instead of Bootstrap affix.
 */
export default function registerDisableSidebarAffix() {
  override(AffixedSidebar.prototype, 'oncreate', function (_original, vnode) {
    Component.prototype.oncreate.call(this, vnode);
  });
  override(AffixedSidebar.prototype, 'onremove', function (_original, vnode) {
    cleanupAffix(this.$());
    Component.prototype.onremove.call(this, vnode);
  });
  override(AffixedSidebar.prototype, 'onresize', function () {
    cleanupAffix(this.$());
  });
}
flarum.reg.add('dia-theme', 'forum/features/disable-sidebar-affix', registerDisableSidebarAffix);